import Vue from 'vue';
import Vuex from 'vuex';

import Auth from './modules/auth';
import Ad from './modules/ad';
import Marketplace from './modules/marketplace';
import Support from './modules/support';
import Dialog from './modules/dialog';
import Balance from './modules/balance';
import Users from './modules/users';
import Company from './modules/company';
import Documents from './modules/documents';
import Reports from './modules/reports';
import lang from './modules/lang';
import currency from './modules/currency';
import promo from './modules/promo';
import Clients from './modules/clients';
import Contracts from './modules/contracts';
import InitialContracts from './modules/initialContracts';
import Creatives from './modules/creatives';
import faq from './modules/faq';
import SetCommissions from './modules/setCommissions';
import Representatives from './modules/representatives';
import Referrals from './modules/referrals';
import Managers from './modules/managers';
import Analytics from './modules/analytics';
import SiteSettings from './modules/site-settings';

export * from './store';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {},
  getters: {},
  mutations: {},
  actions: {},
  modules: {
    Ad,
    Analytics,
    Auth,
    Balance,
    Clients,
    Company,
    Contracts,
    Creatives,
    currency,
    Dialog,
    Documents,
    faq,
    InitialContracts,
    lang,
    Managers,
    Marketplace,
    promo,
    Referrals,
    Reports,
    Representatives,
    SetCommissions,
    SiteSettings,
    Support,
    Users,
  },
});
